// src/components/household-contents/document/DocumentViewer/viewers/index.ts

import { lazy } from "react";

import { Document } from "@/api/rest/models/document";

import { ViewerProps, getDocumentType, is360Image } from "../types";
import { ImageViewer, isImageDocument } from "./ImageViewer";
import { JSONViewer, isJSONDocument } from "./JSONViewer";
import { OfficeViewer, isOfficeDocument } from "./OfficeViewer";
import { PDFViewer } from "./pdf/PDFViewer";

const LazySphere360Viewer = lazy(() => import("./Sphere360Viewer"));

type ViewerComponent = React.FC<ViewerProps>;

export function getDocumentViewer(document: Document): ViewerComponent | null {
  const type = getDocumentType(document);

  if (type === "pdf") {
    return PDFViewer;
  }

  if (is360Image(document)) {
    return LazySphere360Viewer;
  }

  if (isOfficeDocument(type)) {
    return OfficeViewer;
  }

  if (isImageDocument(type)) {
    return ImageViewer;
  }

  if (isJSONDocument(type)) {
    return JSONViewer;
  }

  return null;
}
